export default {
    termsUpdated: 'By continuing to use our service, you are agreeing to our updated <0>terms and conditions.</0>',
    alertError: 'Sorry, something went wrong. Please try again later.',
    alertErrorReportNotFound: "We're sorry, your report could not be found. Please see our support page <0>here</0>.",
    alertErrorReportNotFoundAlt:
        "We're sorry, we seem to have run into an issue with your account. Please see our support page <0>here</0>.",
};
